function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke-width:0px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m17.53,2.63c-.06-.31-.19-.6-.33-.88-.45-.85-1.26-1.49-2.24-1.69-.21-.04-.44-.07-.67-.07H3.3C1.48,0,0,1.48,0,3.3v15.4c0,.23.02.45.07.67.06.31.19.6.33.88.45.85,1.26,1.49,2.24,1.69.21.04.44.07.67.07h11c1.82,0,3.3-1.48,3.3-3.3V3.3c0-.23-.02-.45-.07-.67Zm-2.13,16.07c0,.61-.49,1.1-1.1,1.1H3.3c-.61,0-1.1-.49-1.1-1.1V3.3c0-.61.49-1.1,1.1-1.1h11c.61,0,1.1.49,1.1,1.1v15.4Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.1,4.4h-6.6c-.61,0-1.1.49-1.1,1.1s.49,1.1,1.1,1.1h6.6c.61,0,1.1-.49,1.1-1.1s-.49-1.1-1.1-1.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m12.1,8.8h-6.6c-.61,0-1.1.49-1.1,1.1s.49,1.1,1.1,1.1h6.6c.61,0,1.1-.49,1.1-1.1s-.49-1.1-1.1-1.1Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "m8.8,13.2h-3.3c-.61,0-1.1.49-1.1,1.1s.49,1.1,1.1,1.1h3.3c.61,0,1.1-.49,1.1-1.1s-.49-1.1-1.1-1.1Z"
}));

function SvgForms(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    viewBox: "0 0 17.6 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForms);
export default __webpack_public_path__ + "static/media/Forms.d43c0afd.svg";
export { ForwardRef as ReactComponent };